import React, { useEffect } from 'react';
import { PathRouteProps, useLocation, useNavigate } from 'react-router-dom';
import { Storage } from 'react-jhipster';

import { useAppSelector } from 'app/config/store';
import ErrorBoundary from 'app/shared/error/error-boundary';
import { LOCAL_STORAGE_KEYS } from 'app/shared/util/local-storage-keys';
import { Loader } from 'app/shared/loader/loader';
import CustomRedirect from 'app/shared/util/custom-redirect';

interface IOwnProps extends PathRouteProps {
  hasAnyAuthorities?: string[];
  excludingAuthorities?: string[];
  children: React.ReactNode;
}

export const PrivateRoute = ({ children, hasAnyAuthorities = [], excludingAuthorities = [], ...rest }: IOwnProps) => {
  const sessionHasBeenFetched = useAppSelector(state => state.authentication.sessionHasBeenFetched);
  const account = useAppSelector(state => state.authentication.account);
  const isAuthorized = hasAnyAuthority(account.authorities, hasAnyAuthorities);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!sessionHasBeenFetched && !Storage.local.get(LOCAL_STORAGE_KEYS.PENDING_AUTHENTICATION)) {
      Storage.local.set(LOCAL_STORAGE_KEYS.PENDING_AUTHENTICATION, true);
    } else if (sessionHasBeenFetched && Storage.local.get(LOCAL_STORAGE_KEYS.PENDING_AUTHENTICATION)) {
      Storage.local.remove(LOCAL_STORAGE_KEYS.PENDING_AUTHENTICATION);
    }

    if (!isAuthorized && sessionHasBeenFetched) {
      navigate('/');
    }
  });

  if (!children) {
    throw new Error(`A component needs to be specified for private route for path ${ ( rest as any ).path }`);
  }

  if (isAuthorized) {
    return <ErrorBoundary>{ children }</ErrorBoundary>;
  } else {
    if (!sessionHasBeenFetched) {
      return (
        <div>
          test
          { !sessionHasBeenFetched && <Loader redirect={ true }/> }
          <CustomRedirect to={ location.pathname } search={ location.search }/>
        </div>
      );
    }
  }
};

export const hasAnyAuthority = (authorities: string[], hasAnyAuthorities: string[]) => {
  if (authorities && authorities.length !== 0) {
    if (hasAnyAuthorities.length === 0) {
      return true;
    }
    return hasAnyAuthorities.some(auth => authorities.includes(auth));
  }
  return false;
};

export const useExcludingAuthority = (excludingAuthorities: string[]): boolean => {
  const userAuthorities = useAppSelector(state => {
    return state.authentication.account.authorities
  });

  if (!userAuthorities || userAuthorities.length === 0) {
    return false;
  }

  return excludingAuthorities.some(auth => userAuthorities.includes(auth));
};

/**
 * Checks authentication before showing the children and redirects to the
 * login page if the user is not authenticated.
 * If hasAnyAuthorities is provided the authorization status is also
 * checked and an error message is shown if the user is not authorized.
 */
export default PrivateRoute;
